define('app/filters/FiltersView',['require','./CompoundFilterView','glu/itemView','glu/model','app/editor/dialogs/SaveSegmentDialogView','app/models/Segment','app/models/CompoundFilter','glu/collection','app/editor/dialogs/SelectColumnsDialogView','glu/dialog','hbs!./FiltersView.hbs','app/app','glu/util'],function(require) {
	'use strict';

	var CompoundFilterView = require('./CompoundFilterView'),
		ItemView = require('glu/itemView'),
		Model = require('glu/model'),
		SaveSegmentDialogView = require('app/editor/dialogs/SaveSegmentDialogView'),
		Segment = require('app/models/Segment'),
		CompoundFilter = require('app/models/CompoundFilter'),
		Collection = require('glu/collection'),
		SelectColumnsDialogView = require('app/editor/dialogs/SelectColumnsDialogView'),
		dialog = require('glu/dialog'),
		tmpl = require('hbs!./FiltersView.hbs'),
		App = require('app/app'),
		_ = require('glu/util');


	return ItemView.extend({
		template: tmpl,

		dialog: dialog,

		events: {
			'click #apply-filters': 'runReport',
			'click .button-save': 'saveSegment',
			'click .button-load': 'loadSegment',
			'click .button-add': 'openSelectColumnsDialog',
			'click .add-filter': 'openSelectColumnsDialog'
		},

		initialize: function(options) {
			var self = this;
			this.autoRefresh = options.autoRefresh || false;

			var report = this.model,
				domain = report.get('domain');

			this.topLevelFilterView = new CompoundFilterView({
				model: report.filter(),
				report: report
			});

			this.listenTo(report, 'run change', this.refreshClassesAndStates, this);

			this.listenTo(report, 'change:selected', function() {
				if (this.$el.find('input:checkbox:checked').length > 0) {
					self.$el.find('#segment-save-button').show();
				} else {
					self.$el.find('#segment-save-button').hide();
				}
			});

			this.selectColumnsDialogView = new SelectColumnsDialogView({
				viewMode: 'filters',
				className: 'modal-select-filters',
				model: new Model({
					domain: domain,
					id: Math.random()
				})
			});
		},

		submitButton: function() {
			return this.$el.find('[type=submit]');
		},

		onClose: function() {
			this.topLevelFilterView.close();
		},

		onRender: function() {
			this.$('#report-filters-container').html('').append(this.topLevelFilterView.render().$el);
			this.refreshClassesAndStates();
		},

		isApplyFiltersButtonEnabled: function() {
			return this.model.isRunnable() && this.model.isDirty();
		},

		isApplyFiltersButtonDisabled: function() {
			return !this.isApplyFiltersButtonEnabled();
		},

		isSaveAsSegmentButtonEnabled: function() {
			return !this.model.filter().isEmpty() && !this.model.hasInvalidFilters();
		},

		isSaveAsSegmentButtonDisabled: function() {
			return !this.isSaveAsSegmentButtonEnabled();
		},

		refreshClassesAndStates: function() {
			var self = this;
			_.defer(function() {
				self.$el.toggleClass('has-invalid-filters', self.model.hasInvalidFilters());
				self.$('#apply-filters').prop('disabled', self.isApplyFiltersButtonDisabled());
				self.$('#segment-save-button').prop('disabled', self.isSaveAsSegmentButtonDisabled());
				self.$el.toggleClass('is-empty', self.model.filter().isEmpty());

				if (self.$el.find('.select input:checked').length > 0) {
					self.$el.find('#segment-save-button').show();
				} else {
					self.$el.find('#segment-save-button').hide();
				}
			});
		},

		runReport: function(evt) {
			evt.preventDefault();
			this.model.run();
		},

		saveSegment: function(e) {
			var self = this,
				report = this.model;

			if (e) {
				e.preventDefault();
			}

			//create new segment out of selected filters
			var segment = new Segment();
			segment.setDomainId(report.getDomainId());

			var segmentFilterItems = report.get('filter').get('filterCollection').filter(function(filter) {
				return filter.get('selected');
			});

			var segmentFilter = new CompoundFilter({
				operator: 'AND',
				filterCollection: new Collection(segmentFilterItems)
			});

			segment.setFilter(segmentFilter);
			segment.setIsPrivate(true);

			//open 'Save Segment' dialog
			var saveSegmentDialog = new SaveSegmentDialogView({
				model: segment,
				saveAs: false,
				className: 'modal-save-segment'
			});

			this.dialog.open(saveSegmentDialog);

			saveSegmentDialog.once('saveSegment', function(id) {
				// Remove selected filters, and add them back in as a segment
				if (App && App.segments && App.segments.fetch) {
					App.segments.fetch().then(function() {
						self.removeSelectedFilters();
						report.loadSegmentById(id);
						self.dialog.close();
					});
				}
			});
		},

		removeSelectedFilters: function() {
			var aryModels = [];
			for (var i = 0; i < this.model.filter().filterCollection().models.length; i++) {
				if (this.model.filter().filterCollection().models[i].get('selected')) {
					aryModels.push(this.model.filter().filterCollection().models[i]);
				}
			}

			this.model.filter().filterCollection().remove(aryModels);
		},

		openSelectColumnsDialog: function(evt) {
			evt.preventDefault();

			var self = this;
			var visibleColumnIds = [];

			this.model.eachVisibleColumn(function(column) {
				if (column.get('columnType') === 'FUNCTION') {
					visibleColumnIds.push(column.get('name'));
				} else if (column.get('columnType') === 'SEGMENT') {
					visibleColumnIds.push(column.get('segmentId'));
				} else {
					visibleColumnIds.push(column.fieldId());
				}
			});

			if (App && App.segments && App.segments.fetch) {
				App.segments.fetch().then(function() {
					self.domainSegments = _.where(App.segments.toJSON(), {
						domainId: self.model.get('domain').get('id')
					});

					// renew the view, otherwise events are not picked up
					if (self.selectColumnsDialogView) {
						var report = self.model;
						var domain = report.get('domain');

						self.selectColumnsDialogView.remove();
						self.selectColumnsDialogView = new SelectColumnsDialogView({
							dialogTitle: 'Select Filters ',
							viewMode: 'filters',
							className: 'modal-select-filters',
							modalClass: 'filters',
							dialogButtons: [{
								text: 'Save',
								callback: 'announceSelectedFields',
								className: 'btn-primary btn-filters'
							}, {
								text: 'Save',
								callback: 'announceSelectedSegment',
								className: 'btn-primary btn-segments hidden'
							}, {
								text: 'Cancel',
								callback: 'cancel',
								className: 'btn-link'
							}],
							model: new Model({
								domain: domain,
								report: report,
								id: Math.random(),
								segments: self.domainSegments
							})
						});
						self.selectColumnsDialogView.model.set('topFieldIds', visibleColumnIds);

						self.listenTo(self.selectColumnsDialogView, 'selectFields', function(ids) {
							_.each(ids, function(filter) {
								if (typeof filter === 'string') {
									report.filter().addFilter(domain.buildEmptyFilterForFieldId(filter));
								} else {
									// If object, add the actual values for filters
									report.filter().filterCollection().add(filter.clone());
								}
							});
							self.dialog.close();
							self.appBus.trigger('refresh');
						});

						self.listenTo(self.selectColumnsDialogView, 'selectSegment', function(ids) {
							_.each(ids, function(seg) {
								report.loadSegmentById(seg);
							});
							self.dialog.close();
							self.appBus.trigger('refresh');
						});

						self.listenTo(self.selectColumnsDialogView, 'closeModal', function() {
							self.dialog.close();
						});

					}
					self.dialog.open(self.selectColumnsDialogView);
				});
			}
		},

		templateHelpers: function() {
			var self = this;

			return {
				autoRefresh: self.autoRefresh
			};
		},

		serializeData: function() {
			return this;
		}

	});

});

